// extracted by mini-css-extract-plugin
export var carrierIcon = "_ui-0";
export var carrierLogo = "_ui-1";
export var detailsSection = "_ui-2";